var React = require('react');

var ContextContentMixin = require('./../context_content_mixin');
var CustomStylesMixin = require('./../custom_styles_mixin');
var RevealMixin = require('../reveal_mixin');

var createReactClass = require('create-react-class');
module.exports = createReactClass({

  mixins : [ContextContentMixin, CustomStylesMixin, RevealMixin],

  displayName: 'Maintenance',

  render : function () {
    return (
      <div className="content-container">
        <div className="head-line" style={this.secondary_text_color()}>
          Maintenance
        </div>
        <div className="subheader" style={this.primary_text_color()}>
          We're undergoing a bit of
          scheduled maintenance.
        </div>
        <hr style={this.hrBackgroundColor()} />
        <div className="clearfix"></div>
        <div className="context" style={this.primary_text_color()}>
          { this.contextContent() }
        </div>
        <div className="buttons-container">
          <a href={this.href(this.props.status_page_url)}
             style={this.mergeStyles(this.has_status_page(), this.borderButton())} target="_blank">View Statuspage</a>
        </div>
      </div>
    )
  }

});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/templates/plain/maintenance.jsx